module.exports = __webpack_public_path__ + "static/media/ms.cbd3f274.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ms.svg
// module id = 984
// module chunks = 0